import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SubscribeService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getData(){
        let url = `${this.API_URL}/newsletter`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

    subscribe(email: string, type: string): Observable<any> {
        const url = `${this.API_URL}/subscribers`;
        const requestBody = {
          data: { email, type }
        };
        return this.http.post<any>(url, requestBody, {
          headers: {
            Authorization: `Bearer ${environment.API_TOKEN}`
          }
        });
    }
      
}